import React from 'react';

/**
 * Props for a {@link ProgressBar} component.
 */
export type ProgressBarProps = {
  hidePercentageValue: boolean;
  percentage: number;
  customProgressLabelText?: string;
  textLines?: string[];
};

export function ProgressBar({
  hidePercentageValue,
  percentage,
  customProgressLabelText,
  textLines,
  ...props
}: Readonly<ProgressBarProps>): React.JSX.Element {
  //Style
  const fillerStyles = {
    width: `${percentage}%`
  };
  return (
    <div {...props} className="ehs-progressbar">
      <div
        className="labelStyles"
        hidden={hidePercentageValue}
      >{`${percentage}%`}</div>
      {customProgressLabelText && (
        <div className="labelStyles">{customProgressLabelText}</div>
      )}
      <div className="progressStyles">
        <div className="fillerStyles" style={fillerStyles} />
      </div>

      {textLines?.map(value => {
        return (
          <div key={value} className="textStyles">
            {value}
          </div>
        );
      })}
    </div>
  );
}
